export interface Matcher {
  id?: string
  type: string
  operator: string
  value: string
}

export interface MatcherGroup {
  id: string
  allRequired: boolean
  keyType: string
  price: number
  dttm: string 
  matchers: Matcher[]
}

export interface RulesType {
  id: string
  make?: string
  makeOperator: string
  model?: string
  modelOperator: string
  keyType: string
  minYear?: string | null
  maxYear?: string | null
  price: number
  company?: string
}

export const defaultMatcher: Matcher = {
  id: '',
  type: '',
  operator: '',
  value: ''
}
export const defaultMatcherGroup: MatcherGroup = {
  id: '',
  allRequired: true,
  keyType: '',
  price: 0,
  dttm: '',
  matchers: [defaultMatcher]
}

export const defaultRulesType: RulesType = {
  id: '',
  make: '',
  makeOperator: 'EQUALS',
  model: '',
  modelOperator: 'EQUALS',
  keyType: 'UNSUPPORTED',
  minYear: null,
  maxYear: null,
  price: 0,
  company: ''
};
